<div>
  <mat-drawer-container
    [hasBackdrop]="false"
    autosize
    style="height: calc(100vh - 50px); width: 100%"
  >
    <mat-drawer
      [disableClose]="true"
      #drawer
      mode="side"
      opened
      style="display: block"
    >
      <!-- <mat-toolbar>
                <mat-toolbar-row> -->
      <div class="heading">Categories</div>
      <div *ngIf="!noCategories">
        <div class="input-group-sm mt-2 input-group col-12">
          <input
            class="form-control"
            type="search"
            (keyup)="applyFilterOnCategories($event)"
            (search)="applyFilterOnCategories($event)"
            placeholder="Filter"
          />
        </div>
      </div>

      <div class="m-2 text-center" *ngIf="noCategories">
        No Categories to view
      </div>

      <!-- </mat-toolbar-row>
            </mat-toolbar> -->
      <mat-tree
        *ngIf="!noCategories"
        [dataSource]="categoryTreeData"
        [treeControl]="treeControl"
      >
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          [matTreeNodePaddingIndent]="20"
        >
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button style="min-width: 16px;" disabled></button>
          <button
            mat-button
            [ngClass]="node.id === category ? 'bold-text' : 'normal-text'"
            (click)="selectCategory(node.name, node.id)"
          >
            {{ node.name }}
          </button>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          [matTreeNodePaddingIndent]="20"
        >
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.name"
            style="min-width: 16px;"
          >
            <mat-icon class="mat-icon-rtl-mirror">
              {{
                treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
              }}
            </mat-icon>
          </button>
          <button
            class="mat-tree-child-node"
            mat-button
            [ngClass]="node.id === category ? 'bold-text' : 'normal-text'"
            (click)="selectCategory(node.name, node.id)"
          >
            {{ node.name }}
          </button>
        </mat-tree-node>
      </mat-tree>
    </mat-drawer>

    <mat-drawer-content>
      <div *ngIf="!openUpload">
        <div class="container-fluid">
          <div class="row">
            <!-- Document List -->
            <div class="col mt-1" *ngIf="!hideDocList" style="min-width: 800px">
              <div class="card p-2" *ngIf="!selectedCategory">
                <div class="card-body p-2">
                  <strong>Please select a category</strong><br />
                  1. To view the documents associated with it.<br />
                  2. To upload a document to the selected category.<br />
                </div>
              </div>
              <div *ngIf="selectedCategory">
                <div class="row" *ngIf="!noDocuments">
                  <mat-paginator
                        #myPaginator
                        [pageSizeOptions]="[50, 100]"
                        [pageSize]="50" [pageIndex]="pageIndex" [length]="totalDocumentCount" (page)="selectPage($event)"
                        class="custom-paginator"
                        showFirstLastButtons
                      >
                      </mat-paginator>
                </div>
                <div class="Tabletitle">
                  Document List for Category - {{ categoryName }} ({{
                    totalDocumentCount | number
                  }})
                  <div *ngIf="allowFileSelectFromOtherCategories">
                    Selected Documents: {{ numOfSelectedDocuments | number }}
                    <button
                      *ngIf="numOfSelectedDocuments > 0"
                      class="btn actionButton ml-2"
                      (click)="removeAllSelectedDocs()"
                      mat-raised-button
                    >
                      <mat-icon>clear</mat-icon><span>Clear All</span>
                    </button>

                    <button
                      *ngIf="numOfSelectedDocuments > 0"
                      class="btn actionButton ml-2"
                      (click)="sendDocsForRedaction()"
                      mat-raised-button
                    >
                      <mat-icon>description</mat-icon><span>Redact</span>
                    </button>
                  </div>
                </div>
                <div *ngIf="appError" class="alert alert-info">
                  {{ appError }}
                </div>
                <div class="filtercontainer row">
                  <!-- MCRTX Changes -->
                  <!-- <span *ngIf="selection.selected.length>0">
                                        <button class="uploadbutton" style="margin-bottom: 2px;" mat-raised-button (click)="exportDocuments()"> <mat-icon>cloud_download</mat-icon> Export
                                            </button>
                                    </span> -->

                  <input
                    style="display: none"
                    type="file"
                    (change)="openUploadForm($event.target.files)"
                    #fileInput
                  />
                  <div
                    class="col-4 mt-2 mb-2"
                    role="group"
                    aria-label="First group"
                  >
                    <div class="btn-group">
                      <button
                        class="btn uploadbutton"

                        title="Upload Document"

                        (click)="fileInput.click()"
                        mat-raised-button
                        [disabled]="disableUpload"
                      >
                        <mat-icon>cloud_upload</mat-icon>
                        <!-- <span *ngIf="(selection.selected.length<2)">Upload</span> -->
                      </button>
                      <button
                        mat-raised-button

                        *ngIf="aclGroup.browse.merge"

                        class="btn uploadbutton"
                        title="Merge Documents"
                        (click)="mergeDocuments()"
                      >
                        <mat-icon>mediation</mat-icon>
                      </button>
                      <button
                        mat-raised-button
                        class="btn uploadbutton"
                        title="Delete Documents"
                        (click)="deleteDocuments()"
                        [disabled]="disableDelete"
                      >
                        <mat-icon title="Delete Documents">delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div class="input-group-sm mt-2 mb-2 input-group col-4">
                    <input
                      class="form-control"
                      type="search"
                      [(ngModel)]="filterInput"
                      (keyup)="applyFilter()"
                      (search)="applyFilter()"
                      placeholder="Filter"
                    />
                  </div>
                  <div class="col-4 mb-2 mt-2">
                    <button
                      mat-stroked-button
                      class="btn btn-small"
                      title="refresh"
                      (click)="refresh()"
                      style="float: right"
                    >
                      <mat-icon title="refresh">refresh</mat-icon>
                    </button>
                  </div>
                </div>

                <div *ngIf="noDocuments" class="card">
                  <div class="card-body">
                    {{ categoryName }} has no documents to display.
                  </div>
                </div>
              </div>

              <div
                class="xAxis-scroll-auto mat-elevation-z8"
                *ngIf="docResultsList"
              >
              <div class="row" style="margin-bottom: 1em;">
                  <div class="col-2">
                      <button mat-button [matMenuTriggerFor]="menu">
                          Show/Hide Columns
                          <mat-menu #menu="matMenu">
                            <span class="table-config-menu-label">Edit Columns</span>
                            <div class="table-config-menu-options">
                              <mat-checkbox 
                                *ngFor="let cd of selectedFormDisplayList; let i = index"
                                (click)="$event.stopPropagation()"
                                [(ngModel)]="cd.visible">
                                {{cd.name}}
                              </mat-checkbox>
                              <button (click)="applyShowHideColumns()">Apply</button>
                            </div>
                        </mat-menu>
                      </button>
                  </div>           
                </div>
                <table
                  mat-table
                  [dataSource]="docResultsList"
                  matSortActive="create_date"
                  matSortDirection="desc"
                  matSort
                  aria-describedby="document-list"
                >
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        #ref
                        (change)="$event ? masterToggle(ref) : null"
                        [checked]="
                          allowFileSelectFromOtherCategories
                            ? isAllSelected()
                            : selection.hasValue() && isAllSelected()
                        "
                        [indeterminate]="
                          allowFileSelectFromOtherCategories
                            ? calcIndeterminate() && !isAllSelected()
                            : selection.hasValue() && !isAllSelected()
                        "
                      >
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="
                          $event ? selection.toggle(row.documentId) : null;
                          isSomeSelected();
                          allowFileSelectFromOtherCategories
                            ? documentSelected($event, row.documentId)
                            : null
                        "
                        [checked]="
                          allowFileSelectFromOtherCategories
                            ? selection.isSelected(row.documentId) ||
                              isDocumentSelected(row.documentId)
                            : selection.isSelected(row.documentId)
                        "
                      >
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <!-- <ng-container matColumnDef="title">
                    <th
                      id="title"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Document Title
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)">
                      <span
                        *ngIf="element.metadata.system.type.endsWith('pdf')"
                      >
                        <mat-icon svgIcon="pdf"></mat-icon>
                      </span>
                      <span
                        *ngIf="
                          element.metadata.system.type.endsWith('jpeg') ||
                          element.metadata.system.type.endsWith('png')
                        "
                      >
                        <mat-icon svgIcon="jpeg"></mat-icon>
                      </span>
                      <span
                        *ngIf="
                          element.metadata.system.type.endsWith('presentation')
                        "
                      >
                        <mat-icon svgIcon="ppt"></mat-icon>
                      </span>
                      <span
                        *ngIf="
                          element.metadata.system.type.endsWith('sheet') ||
                          element.metadata.system.type.endsWith('excel')
                        "
                      >
                        <mat-icon svgIcon="xls"></mat-icon>
                      </span>
                      <span
                        *ngIf="element.metadata.system.type.endsWith('plain')"
                      >
                        <mat-icon svgIcon="txt"></mat-icon>
                      </span>
                      <span
                        *ngIf="
                          element.metadata.system.type.endsWith('document')
                        "
                      >
                        <mat-icon svgIcon="doc"></mat-icon>
                      </span>
                      {{ element.documentName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="create_date">
                    <th
                      id="create_date"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Uploaded date
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)">
                      {{ element.createdDate | date }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="created_by" >
                    <th
                      id="created_by"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Uploaded By
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)">
                      {{ element.created_by }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="modified_date">
                    <th
                      id="modified_date"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Modified date
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)">
                      {{ element.modifiedDate | date }}
                    </td>
                  </ng-container> -->

                  <!-- dynamic columns -->
                  <ng-container *ngFor="let column of selectedFormDisplayList">
                    <ng-container  *ngIf = "column.visible && column.type == 'original'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)" >
                        {{ element[column.value] }}
                      </td>
                    </ng-container>
                    <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type == 'object'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)" >
                        {{ element.metadata.properties[column.value] | json}}
                      </td>
                    </ng-container>
                    <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type != 'object'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)" >
                        {{ element.metadata.properties[column.value] }}
                      </td>
                    </ng-container>
                    <ng-container  *ngIf = "column.visible && column.type == 'system'"                    
                      matColumnDef="{{ column.name }}"
                    >
                      <th
                        id="{{ column.name }}"
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                      >
                        {{ column.name  }}
                      </th>
                      <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element.documentId, drawer, element)" >
                        {{ element.metadata.system[column.value] }}
                      </td>
                    </ng-container>
                  </ng-container>
                  <!-- end dynamic columns-->
                  <ng-container matColumnDef="actionButton">
                    <th id="actionButton" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button [matMenuTriggerFor]="menu" (click)="subscribe(element)"
>
                            <mat-icon>list</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openUpdateMetaData()" [disabled]="isDocLocked">Update
                                Metadata</button>
                            <button mat-menu-item (click)="openUploadDocument()" [disabled]="isDocLocked">Upload
                                Version</button>                            
                            <button mat-menu-item (click)="lockUnlockDocument(activeDocumentDetails.locked)">
                                <div *ngIf=isDocLocked>Unlock Document</div>
                                <div *ngIf=!isDocLocked>Lock Document</div>
                            </button>
                        </mat-menu>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: documentCols"                    
                    class="element-row"
                    [class.selected-row]="selectedRow === row"
                    (click)="selectedRow = selectedRow === row ? null : row"
                  ></tr>
                </table>                
              </div>              
            </div>
            <!-- End Document List -->
            <!-- File Properties -->
            <div class="col" *ngIf="selectedDoc && hideDocList">
              <app-display-search-doc
                [selectedDocument]="selectedDoc"
                [categoryPermissions]="categoryPermissions"
                [searchResultsList]="docResultsList"
                (hideDocList)="onHideDocList($event)"
              >
                <!-- (hideDocListWithCategoryChange)="onHideDocListWithCategoryChange($event.param1, $event.param2, $event.param3)" -->
              </app-display-search-doc>
            </div>
            <div class="col-4" *ngIf="openVersionUpload">
              <app-dialog-upload [documentDetails]="activeDocumentDetails" (close)="closeTabs($event)"
                  (openUpload)="backFromUpload($event)">
              </app-dialog-upload>
            </div>
            <div class="col-4" *ngIf="openMetaData">
              <app-dialog-update [document]="activeDocumentDetails" (close)="closeTabs($event)"
                  (openMetaData)="backFromMetaData($event)">
              </app-dialog-update>
            </div>
            <!-- End File Properties -->
          </div>
        </div>
      </div>
      <div *ngIf="openUpload">
        <app-dialog-uploadfile
          [categoryId]="categoryId"
          [fileToUpload]="fileToUpload"
          (openUpload)="back($event)"
        ></app-dialog-uploadfile>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

  <ng-template #redactionPopup>
    <div class="card mt-3">
      <div class="card-body" style="text-align: center">
        {{ tempMessage }}
        <div>
          <button
            mat-dialog-close
            class="closeButton float-right m-2"
            mat-raised-button
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
